module.exports = __webpack_public_path__ + "img/22.450e8e03.png";